export default {
  name: 'CategoryContentReviewDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    fieldLabel: {
      type: String,
      default: ''
    },
    targets: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    title () {
      const count = this.targets.length
      if (!count) return 'Review upload'
      return count === 1 ? `Review ${this.fieldLabel} upload` : `Review ${this.fieldLabel} upload for ${count} categories`
    }
  },
  methods: {
    close () {
      if (this.loading) return
      this.localValue = false
      this.$emit('cancel')
    },
    confirm () {
      this.$emit('confirm')
    },
    truncateText (value, maxLength = 160) {
      if (!value) return '-'
      const normalized = String(value).trim()
      if (normalized.length <= maxLength) return normalized
      return `${normalized.slice(0, maxLength).trim()}...`
    }
  }
}
